import brown from '@material-ui/core/colors/brown';
import blueGrey from '@material-ui/core/colors/blueGrey';

export default {
  palette: {
    type: 'light',
    primary: blueGrey,
    secondary: brown
  }
};